import * as Yup from 'yup';

const siteSchema = Yup.object().shape({
    Site_ID: Yup.number()
        .typeError('Site ID must be a number'),
    Name: Yup.string()
        .required('Site name is required'),
    Description: Yup.string().nullable(),
    location: Yup.string()
        .typeError('Address is required').required('Address is required'),
    Work_hours: Yup.number()
        .typeError('Work Hours is required')
        .required('Work Hours is required'),
    nbr_workers: Yup.number()
        .typeError('Number of workers is required')
        .required('Number of workers is required'),
    Company_ID: Yup.number()
        .typeError('Company ID must be a number')
});

export const validateSite = (siteData) => {
    return siteSchema.validate(siteData, { abortEarly: false });
};

export default siteSchema;
